import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { takeUntil } from 'rxjs/operators';
import { NgProgressService } from '../../services/ngProgress.service';
import { MatTableDataSource } from '@angular/material/table';
import { DatePipe } from '@angular/common';
import { DDCustomer, UpdateCustomerSubscriptionsModel } from '../../models/customer.model';
import { CustomerService } from '../../services/customer.service';

@Component({
  selector: 'app-manage-customer',
  templateUrl: './manage-customer.component.html',
  styleUrls: ['./manage-customer.component.css'],
  providers: [DatePipe]
})
export class ManageCustomerComponent implements OnInit, OnDestroy {

  private customerList: DDCustomer[] = [];
  public displayedColumns: string[] = ['programName', 'manage'];
  public dataSource: MatTableDataSource<UpdateCustomerSubscriptionsModel>
  public customer: DDCustomer;
  public customerId: string;
  public narrowMode = false;
  public showRest = true;
  public showRest2 = false;
  public customerPrograms: UpdateCustomerSubscriptionsModel[] = [];
  public activePrograms: UpdateCustomerSubscriptionsModel[] = [];
  public programSearchField = '';

  // filter
  public searchField = '';

  purchase: string;
  selectedTabIndex = 0;
  selectMonthlyPayment = false;
  programName: string;
  ngUnsubscribe: Subject<void> = new Subject<void>();
  isStaffAccount = false;
  public loadingPrograms = false;

  constructor(
    private customerService: CustomerService,
    public cs: CommonService,
    public ngProgress: NgProgressService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public authService: AuthService
  ) {
  }

  async ngAfterViewInit() {
    await this.cs.waitForElm('#levelOne');
    if (
      !$('#enroll-program').length &&
      !$('#customer-form').length 
    ) {
      $('#levelOne').animate({ scrollLeft: 0 }, 400);
    }
  }

  ngOnInit() {
    this.setupChildView();
    this.setupCustomer();
    this.setupCustomerList();
    this.setupCustomerProgramsRefresh();
  }

  private setupCustomerProgramsRefresh(): void {
    this.customerService.refetchCustomerPrograms$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
      this.fetchCustomerPrograms();
    });
  }

  private setupCustomerList(): void {
    this.customerService.currentCustomerListWatch
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((customerList) => {
        if (customerList?.length) {
          this.customerList = customerList;
          this.setCustomer();
        }
      });
  }
  
  private setupCustomer(): void {
    this.activatedRoute.paramMap.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => this.setCustomer());
  }

  private setupChildView(): void {
    this.narrowMode = false;
    this.adjustChildView();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.adjustChildView();
      }
    });
  }

  private setCustomer(): void {
    const customerId = this.activatedRoute.snapshot.paramMap.get('customerId');
    if (this.customer?.id != customerId) {
      this.fetchCustomerPrograms();
    }
    this.customer = new DDCustomer(this.customerList?.find(c => c.id === customerId));
    this.customerService.monitorCustomer(this.customer);
  }

  private fetchCustomerPrograms(): void {
    const customerId = this.activatedRoute.snapshot.paramMap.get('customerId');
    this.loadingPrograms = true;
    this.customerService.getSubscriptionProgramsByCustomerId(customerId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: UpdateCustomerSubscriptionsModel[]) => {
        this.customerPrograms = [ ...res ];
        this.dataSource = new MatTableDataSource(this.customerPrograms);
        this.customerService.monitorCustomerPrograms(this.customerPrograms);

        this.loadingPrograms = false;
      });
  }

  private adjustChildView(): void {
    const customerId = this.activatedRoute.snapshot.paramMap.get('customerId');
    if (this.urlContains('edit-customer') || this.urlContains('enroll-program')) {
      this.narrowMode = false;
      this.showRest2 = true;
      this.showRest = false;
    } else if (this.router.url !== `/customers/${customerId}`) {
      this.narrowMode = true;
    } else {
      this.narrowMode = false;
    }
  }

  private urlContains(url: string): boolean {
    return this.router.url.includes(url);
  }

  public editCustomerDetail(event): void {
    this.showRest2 = true;
    this.showRest = false;
    this.router.navigate(['edit-customer'], { relativeTo: this.activatedRoute });
  }

  public manageCustomerProgramEvent(program: UpdateCustomerSubscriptionsModel): void {
    if (this.narrowMode) {
      this.showRest = false;
      $('app-manage-csp-details').hide("slide", { direction: "left" }, 400).promise().then(() => {
        this.showRest = true;
        this.showRest2 = false;
        this.router.navigate([`${program?.programType}/${program?.vendorCustomerId}`], {
          relativeTo: this.activatedRoute,
        });
        $('app-manage-csp-details').show("slide", { direction: "left" }, 400);
      });
    } else {
      this.narrowMode = true;
      this.showRest = true;
      this.showRest2 = false;
      this.router.navigate([`${program?.programType}/${program?.vendorCustomerId}`], {
        relativeTo: this.activatedRoute,
      });
    }

  }

  public  isActive(programType?: string, cmsId?: string): boolean {
    const urlArray = this.router.url.split('/');
    return urlArray.indexOf(programType) > -1 || urlArray.indexOf(cmsId ? cmsId : null) > -1;
  }

  public enrollProgramEvent() {
    this.showRest2 = true;
    this.showRest = false;
    this.router.navigate(['enroll-program'], { relativeTo: this.activatedRoute });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public close() {
    this.router.navigate(['../'], { relativeTo: this.activatedRoute });
  }
}
